<div class="spinner-overlay" *ngIf="printService.isPrinting">
    <mat-spinner></mat-spinner>
    <h2 i18n>waiting for Print</h2>
</div>

<div [class.isPrinting]="printService.isPrinting" class="full-height">
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">
    <router-outlet></router-outlet>
</div>
<div [class.isPrintingPrintContainer]="printService.isPrinting" class="printContainer">
    <router-outlet name="print"></router-outlet>
</div>

<mat-toolbar color="primary" class="footer">
    <span i18n>-company Name-</span>
    <span class="spacer"></span>
    <div class="footer-links">
        <a mat-button i18n-href href="https://www.yourcompany.com/impressum" target="_blank" i18n>Impressum</a>
        <a mat-button i18n-href href="/privacy-policy" target="_blank" i18n>Datenschutz</a>
        <a mat-button i18n (click)="openCookieConsentDialog()">Cookies</a>
    </div>
</mat-toolbar>